import _ from "underscore";
import { slugify } from "./stringHelpers";
import { app } from "../model/AppModel";
import { routes } from "../provider/routes";
import store from "@src/store";
import {
  GATSBY_SOURCE_SUSHISHOP_BASE_URL,
  IMAGE_CDN_BASE_URL,
} from "@src/utils/constants";

// Object de portée globale pour fabriquer les URL
declare global {
  interface Window {
    UrlFactory: any;
  }
}

export const getIsoLang = () => {
  const currentPage = store.getState().page.currentPageContextIntl;
  return currentPage && currentPage.lang ? currentPage.lang : "fr";
};

const getRouteUrl = (
  id_route: string | number,
  ignoreBaseUrl?: boolean,
  ignoreLang?: boolean
) => {
  const path = routes[id_route] || "";
  return _.template(
    (ignoreBaseUrl ? "" : GATSBY_SOURCE_SUSHISHOP_BASE_URL) +
      "/" +
      (ignoreLang ? "" : (getIsoLang() || "fr").toLowerCase() + "/") +
      (path || "")
  );
};

function getDomainShardingImgUrl(path: string) {
  return IMAGE_CDN_BASE_URL + "/" + path;
}

const UrlFactory = {
  // retourne l’url complete
  getUrl: function (
    route: any,
    options?: Record<string, any>,
    ignoreBaseUrl: boolean = false,
    ignoreLang: boolean = false
  ) {
    if (!options) {
      options = {};
    }
    options.c = app.c;
    if (!options.rewrite) {
      options.rewrite = "";
    }
    return UrlFactory.getUrlTemplate(route, ignoreBaseUrl, ignoreLang)(options);
  },
  // retourne la route
  getRoute: function (
    route: any,
    options: any,
    ignoreBaseUrl: boolean = true,
    ignoreLang: boolean = true
  ) {
    return UrlFactory.getUrl(route, options, ignoreBaseUrl, ignoreLang);
  },
  getUrlTemplate: function (
    route: any,
    ignoreBaseUrl?: boolean,
    ignoreLang?: boolean
  ) {
    return getRouteUrl(route, ignoreBaseUrl, ignoreLang);
  },
  getUrlPicture: function (
    id_picture: string,
    type: string,
    format: string,
    rewrite: any,
    extension: string
  ) {
    const path =
      type +
      "-" +
      id_picture +
      "-" +
      format +
      "/" +
      slugify(rewrite) +
      "." +
      extension.toLowerCase();
    return getDomainShardingImgUrl(path);
  },
};

if (typeof window !== "undefined") {
  // Global scope
  window.UrlFactory = UrlFactory;
}

export default UrlFactory;
